import { mplService } from './Services';

export default {
  isAppAuthenticated,
};

function isAppAuthenticated() {
  const authHeader = mplService.defaults.headers.common.Authorization;
  return !!authHeader;
}
